/** Used when `requestIdleCallback` is unavailable (Safari) to load analytics after first paint. */
export const ANALYTICS_IDLE_LOAD_FALLBACK_MS = 2000;
